import { IPageData, IPageParams } from "../types"

/**
 * 故障大类
 * $t('enum.E_FaultTagType.RotorFailure')
 * $t('enum.E_FaultTagType.BearingFailure')
 * $t('enum.E_FaultTagType.GearFailure')
 * $t('enum.E_FaultTagType.Normal')
 */
export enum E_FaultTagType {
    RotorFailure = 'RotorFailure',
    BearingFailure = 'BearingFailure',
    GearFailure = 'GearFailure',
    Normal = 'Normal',
}

/**
 * 图谱类别
 * $t('enum.E_FaultTagGraphCategory.RotorNor')
 * $t('enum.E_FaultTagGraphCategory._1X')
 * $t('enum.E_FaultTagGraphCategory._1_2X')
 * $t('enum.E_FaultTagGraphCategory._1_10X')
 * $t('enum.E_FaultTagGraphCategory.BearingNor')
 * $t('enum.E_FaultTagGraphCategory.BPFO')
 * $t('enum.E_FaultTagGraphCategory.BPFI')
 * $t('enum.E_FaultTagGraphCategory.BSF')
 * $t('enum.E_FaultTagGraphCategory.SideBandNor')
 * $t('enum.E_FaultTagGraphCategory.SideBand')
 * $t('enum.E_FaultTagGraphCategory.ImpulseNor')
 * $t('enum.E_FaultTagGraphCategory.Impulse')
 */
export enum E_FaultTagGraphCategory {
    RotorNor = 'RotorNor',
    _1X = '1X',
    _1_2X = '1-2X',
    _1_10X = '1-10X',
    BearingNor = 'BearingNor',
    BPFO = 'BPFO',
    BPFI = 'BPFI',
    BSF = 'BSF',
    SideBandNor = 'SideBandNor',
    SideBand = 'SideBand',
    ImpulseNor = 'ImpulseNor',
    Impulse = 'Impulse',
}


export interface IFaultTagGraphCategoryItem {
    /**
     * 图谱类别
     */
    graphCategory: string
    /**
     * 标签ID前缀
     */
    labelPrefix: string
}

export interface IFaultTagLibraryBase {
    /**
     * 轴向
     */
    axis: string
    /**
     * 轴承型号SDE
     */
    bearingModelSde: string
    /**
     * 轴承型号SNDE
     */
    bearingModelSnde: string
    /**
     * 故障类型
     */
    faultType: string
    /**
     * 图谱类别
     */
    graphCategory: string
    /**
     * 标签ID前缀
     */
    labelPrefix: string
    /**
     * 额定转速
     */
    ratedSpeed: number
    /**
     * 备注
     */
    remark: string
}

export interface IFaultTagLibraryAddParams extends IFaultTagLibraryBase {
    /**
     * 波形ID
     */
    waveId: number
}

export interface IFaultTagLibraryEditParams extends IFaultTagLibraryBase {
    /**
     * 主键ID
     */
    id: number
}

export interface IFaultTagLibraryQueryParams extends IPageParams {
    /**
     * 轴向
     */
    axis?: string
    /**
     * 公司ID
     */
    companyId?: number
    /**
     * 结束
     */
    endTime?: string
    /**
     * 故障类型
     */
    faultType?: string
    /**
     * 图谱类别
     */
    graphCategory?: string
    /**
     * 主键id
     */
    id?: number
    /**
     * 标签ID
     */
    labelId?: string
    /**
     * 标注结束时间
     */
    markEndTime?: string
    /**
     * 标注开始时间
     */
    markStartTime?: string
    /**
     * 额定转速
     */
    ratedSpeed?: number
    /**
     * 采样频率
     */
    sampleFrequency?: string
    /**
     * 采样点数
     */
    samplePoints?: number
    /**
     * 传感器ID
     */
    sensorId?: string
    /**
     * 开始时间
     */
    startTime?: string
    /**
     * 波形结束时间
     */
    waveEndTime?: string
    /**
     * 波形ID
     */
    waveId?: number
    /**
     * 波形开始时间
     */
    waveStartTime?: string
}

export interface IFaultTagLibraryListItem {
    /**
     * 区域名称
     */
    areaName: string
    /**
     * 轴向
     */
    axis: string
    /**
     * 公司名称
     */
    companyName: string
    /**
     * 部件名称
     */
    componentName: string
    /**
     * 设备名称
     */
    equipmentName: string
    /**
     * 故障类型
     */
    faultType: string
    /**
     * 图谱类别
     */
    graphCategory: string
    /**
     * 主键ID
     */
    id: number
    /**
     * 标签ID
     */
    labelId: string
    /**
     * 测点映射ID
     */
    mappingId: number
    /**
     * 标注时间
     */
    markTime: string
    /**
     * 标注人
     */
    marker: string
    /**
     * 测点名称
     */
    pointName: string
    /**
     * 额定转速
     */
    ratedSpeed: number
    /**
     * 备注
     */
    remark: string
    /**
     * 采样频率
     */
    sampleFrequency: string
    /**
     * 采样点数
     */
    samplePoints: number
    /**
     * 传感器ID
     */
    sensorId: string
    /**
     * 波形ID
     */
    waveId: number
    /**
     * 波形时间
     */
    waveTime: string
}

export interface IFaultTagLibraryDefaultData {
    /**
     * 区域ID
     */
    areaId: number
    /**
     * 区域名称
     */
    areaName: string
    /**
     * 轴向
     */
    axis: string
    /**
     * 轴承型号SDE
     */
    bearingModelSde: string
    /**
     * 轴承型号SNDE
     */
    bearingModelSnde: string
    /**
     * 公司ID
     */
    companyId: number
    /**
     * 公司名称
     */
    companyName: string
    /**
     * 部件ID
     */
    componentId: number
    /**
     * 部件名称
     */
    componentName: string
    /**
     * 设备ID
     */
    equipmentId: number
    /**
     * 设备名称
     */
    equipmentName: string
    /**
     * 测点映射ID
     */
    mappingId: number
    /**
     * 总公司ID
     */
    parentCompanyId: number
    /**
     * 测点名称
     */
    pointName: string
    /**
     * 额定转速
     */
    ratedSpeed: number
    /**
     * 采样频率
     */
    sampleFrequency: string
    /**
     * 采样点数
     */
    samplePoints: number
    /**
     * 传感器ID
     */
    sensorId: string
    /**
     * 传感器类型
     */
    sensorType: string
    /**
     * 波形ID
     */
    waveId: number
    /**
     * 波形时间
     */
    waveTime: string
}

export interface IFaultTagLibraryDetailData extends IFaultTagLibraryDefaultData {
    /**
     * 故障类型
     */
    faultType: string
    /**
     * 图谱类别
     */
    graphCategory: string
    /**
     * 主键ID
     */
    id: number
    /**
     * 标签ID
     */
    labelId: string
    /**
     * 标签ID前缀
     */
    labelPrefix: string
    /**
     * 标注时间
     */
    markTime: string
    /**
     * 标注人
     */
    marker: string
    /**
     * 备注
     */
    remark: string
}

export interface IFaultTagLibraryMarkDefaultParams {
    /**
     * 波形ID
     */
    waveId: number
}

export type IFaultTagLibraryPageData = IPageData<IFaultTagLibraryListItem>
export type IFaultTagLibraryGraphCategoriesData = IFaultTagGraphCategoryItem[]
